// extracted by mini-css-extract-plugin
export default {"Login":"Login_Login__-Dn9o","close":"Login_close__4W1ND"};